<template>
  <v-text-field
      rounded="lg"
      :error-messages="error"
      :label="translation(translationList.last_name, 'Nume')"
      v-model="lastName"
      :rules="lastNameValidationRules"
      name="last_name"
      variant="outlined"
      bg-color="surface"
      :tile="true"
  >
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, toRefs } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: String as () => string | null,
    customerIndex: Number as () => number | null,
  },
  setup(props, { emit }) {
    const { modelValue, customerIndex } = toRefs(props);
    const lastName = ref(modelValue.value ? modelValue.value : '');
    const error = ref([]);

    watch(modelValue, (newValue) => {
      lastName.value = newValue;
    });

    watch(lastName, (newValue) => {
      const isValid = validateLastName(newValue);
      if (isValid) {
        emit('update:modelValue', newValue);
      } else {
        emit('update:modelValue', null);
      }
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `last_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `last_name`, isValid });
      }
    });

    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();

    const lastNameValidationRules = [
      (v: string) => !!v || translation(translationList.value.required, 'Acest câmp este obligatoriu'),
      (v: string) => /^[A-Za-z\s-]+$/.test(v) || translation(translationList.value.invalid_field, 'Acest câmp este invalid.'),
    ];

    function validateLastName(value: string, showErrors?: boolean): boolean {
      error.value = [];
      if (showErrors) {
        const errors = lastNameValidationRules
            .map(rule => rule(value))
            .filter(result => result !== true) as string[];
        if (errors && errors.length > 0) {
          error.value = errors;
          return false;
        }
      }
      return lastNameValidationRules.every(rule => rule(value) === true);
    }

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      const isValid = validateLastName(lastName.value);
      if (customerIndex.value !== undefined) {
        emit('validation-customer-status', { field: `last_name-${customerIndex.value}`, isValid });
      } else {
        emit('validation-customer-status', { field: `last_name`, isValid });
      }

      window.addEventListener('validate-customer', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && (data.detail === `last_name-${customerIndex.value}` || data.detail === `last_name`)) {
        const isValid = validateLastName(lastName.value, true);
        if (isValid) {
          emit('validation-customer-status', { field: data.detail, isValid });
        }
      }
    };

    return {
      lastName,
      lastNameValidationRules,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>
